<app-page-header title="Messages" [breadcrumbs]="breadcrumb"></app-page-header>

<section class="content">
  <div class="container-fluid">
    <div class="col-lg-12">
      <mat-card class="diagnostic">
        <mat-card-header
          class="loading-header"
          [ngClass]="{ loading: loading }"
        >
          <mat-progress-bar
            mode="indeterminate"
            *ngIf="loading"
          ></mat-progress-bar>
        </mat-card-header>
        <div class="title">
          <h3>Diagnostic</h3>
          <button mat-mini-fab color="primary" (click)="getDiagnostic()">
            <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <pre>{{ diagnosticResponse | json }}</pre>
      </mat-card>
      <app-messages-form></app-messages-form>
    </div>
  </div>
</section>
